module.exports = __webpack_public_path__ + "media/revengeOfCats.85cb82d2.mp3";